import React from "react";

import type { Location } from "history";

import AccountStore from "~/account/AccountStore";
import type { SettingsModalProps } from "~/settings/SettingsModal";

import type { AppQuery$data } from "~/__generated__/AppQuery.graphql";

export interface AppContextInterface {
	user?: AppQuery$data["user"] & {
		id: string;
		fullName: string;
		hasAdminAccess: boolean;
		hasAccessToCopilot: boolean;
		uxSimplificationEnabled: boolean;
	};
	account?: AppQuery$data["account"];
	handleUtmAnalytics?: (location: Location) => void;
	setSidebar?: (sidebar: "search" | "shortcuts" | null) => void;
	getSidebar?: () => "search" | "shortcuts" | null;
	closeSidebar?: () => void;
	openSettingsModal: (defaultSection?: SettingsModalProps["defaultSection"]) => void;
}

/**
 * @deprecated Get things from the Relay store if you can.
 */
const AppContext = React.createContext<AppContextInterface>({
	openSettingsModal: () => {
		throw new Error("No app context");
	},
});
AppContext.displayName = "AppContext";

interface AppContextProps {
	value: AppContextInterface;
	children: React.ReactNode;
}

export function AppContextProvider({ value, children }: AppContextProps) {
	React.useEffect(() => {
		if (value.account) AccountStore.put(value.account);
	}, [value.account]);

	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export default AppContext;
